import { Badge } from "@/components/ui/badge";
import { Link2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface SourceBadgeProps {
  sources: string[];
  className?: string;
}

const SOURCE_LABELS: Record<string, string> = {
  matrix_weighted_scores: "Matrix",
  best_option_calculation: "Score-Berechnung",
  decision_steps: "Phase 1",
  scenarios: "Optionen",
  decision_matrix_entries: "Bewertungsmatrix",
  tie_resolution: "Tie-Breaking",
  user_context: "Nutzer-Kontext",
  decision_steps_by_user: "Team-Antworten",
};

export const SourceBadge = ({ sources, className }: SourceBadgeProps) => {
  if (!sources || sources.length === 0) return null;

  return (
    <div className={cn("flex flex-wrap gap-1", className)}>
      {sources.map((source) => (
        <Badge
          key={source}
          variant="outline"
          className="text-[10px] px-1.5 py-0 h-5 font-normal text-muted-foreground border-border/50 gap-1"
        >
          <Link2 className="h-2.5 w-2.5" />
          {SOURCE_LABELS[source] || source}
        </Badge>
      ))}
    </div>
  );
};
